<template>
  <div class="home1">
    <div class="wrap">
      <div class="header">
        <h1 class="icon logo">
          <a
            class="wh100"
            href="javascript:;"
            @click="$router.push({ name: 'lingliu' })"
            ><span class="none">永恒岛M</span></a
          >
        </h1>
        <ul class="nav">
          <li class="">
            <a href="javascript:;" @click="$router.push({ name: 'lingliu' })"
              >官網首頁<br /><i>HOME</i></a
            >
          </li>
          <li class="">
            <a href="javascript:;">隱私政策<br /><i>PRIVACY POLICY</i></a>
          </li>
          <li class="">
            <a
              href="javascript:;"
              @click="$router.push({ name: 'lingliu.terms' })"
              >服務條款<br /><i>Terms Of Use</i></a
            >
          </li>
        </ul>
      </div>
      <div class="clearfix sectionInM">
        <div class="title">
          <a href="javascript:;" @click="$router.push({ name: 'lingliu' })"
            >首頁</a
          ><span>&gt;</span>隱私政策
        </div>
        <div class="content">
          <div class="article">
            <div class="abody">
              <p><strong>個人資料暨隱私權保護政策</strong></p>
              <p>LINGLUK&nbsp;NETWORK「個人資料暨隱私權保護政策」聲明：</p>
              <p>
                LINGLUK&nbsp;NETWORK（以下簡稱&nbsp;LINGLUK&nbsp;NETWORK）為保障您個人資料之安全性，特針對您個人的隱私權擬定「個人資料暨隱私權&nbsp;保護政策」聲明（PrivacyPolicy，下簡稱隱私權政策），讓您瞭解LINGLUK&nbsp;NETWORK對於您的隱私權之尊重與保護，並告訴您有關您個人資料之相關資訊。本&nbsp;政策讓您瞭解LINGLUK&nbsp;NETWORK在蒐集您的個人資料時：
              </p>
              <p>1.本公司的名稱。</p>
              <p>2.蒐集之目的。</p>
              <p>3.個人資料之類別。</p>
              <p>4.個人資料利用之期間、地區、對象及方式。</p>
              <p>5.您得行使之權利及方式。</p>
              <p>6.若您無法提供完整的個人資料時，不提供將對您權益之影響。</p>
              <p>7.個人資料的安全維護</p>
              <p>&nbsp;</p>
              <p>請您詳細閱讀LINGLUK&nbsp;NETWORK「隱私權政策」</p>
              <p>&nbsp;</p>
              <p>一、適用範圍</p>
              <p>
                LINGLUK&nbsp;NETWORK「隱私權政策」適用於您在遊戲內與其所附屬之網站活動時，所涉及的個人資料蒐集、處理、利用、國際傳遞以及保護措施。但不適用於經LINGLUK&nbsp;NETWORK網站而連結至第三人經營的網站或網頁。
              </p>
              <p>&nbsp;</p>
              <p>二、資料蒐集之目的及類別</p>
              <p>
                根據LINGLUK&nbsp;NETWORK所提供不同服務目的，LINGLUK&nbsp;NETWORK可能蒐集您的個人資料類別及情形如下：
              </p>
              <p>&nbsp;</p>
              <p>進行遊戲</p>
              <p>
                當您申請進入遊戲時，LINGLUK&nbsp;NETWORK將蒐集您的個人資料，包括姓名、暱稱、身份證字號、電話、電子信箱等相關必&nbsp;要資料，成為會員後，您將會獲得一個會員的帳號與密碼，並由本組帳號、密碼登入使用會員的各項服務。LINGLUK&nbsp;NETWORK亦會蒐集您的電腦硬體、軟件和行動電話裝置的&nbsp;資料。包括您的IP位置、瀏覽器類型、登入時間以及網站地址等必要資訊。
              </p>
              <p>
                LINGLUK&nbsp;NETWORK會利用此等資料協助維持遊戲運作和服務品質。
              </p>
              <p>&nbsp;</p>
              <p>「線上交易」</p>
              <p>
                如您選擇使用線上交易服務，將會依照你提出的線上交易形態，蒐集您所填寫的訂單相關資料，以確保您完成付款、儲值或物流等消費服務。
              </p>
              <p>&nbsp;</p>
              <p>「線上活動」</p>
              <p>
                您若因參加LINGLUK&nbsp;NETWORK舉辦之線上活動或網路調查時，關於您個人資料將直接由會員資料庫提供進行核對。惟若該項活動仍需您配合補充相關資料時，請詳細登錄所需之資料。惟該此補充資料，亦一併受到隱私權政策之保護。
              </p>
              <p>&nbsp;</p>
              <p>「瀏覽網頁」</p>
              <p>
                當您於LINGLUK&nbsp;NETWORK站內或其附屬網站中瀏覽或查詢時，LINGLUK&nbsp;NETWORK伺服器將自動紀錄您使用連線之IP位置、時間及瀏覽相關記錄。這些資料僅供作流量統計分析及網路服務優化，以便於改善LINGLUK&nbsp;NETWORK的服務品質，這些資料僅作為總量上的分析，不會和特定個人相連繫。
              </p>
              <p>&nbsp;</p>
              <p>「其他」</p>
              <p>
                除了您直接提供的個人資料之外，您也可能在LINGLUK&nbsp;NETWORK合作廠商處主動提供個人資料，並在您同意或為履行契約目的前提下，將您的個人資料提供給LINGLUK&nbsp;NETWORK。這些資料只會在您同意或為履行契約的服務範圍內利用及處理，不會用於其他用途。
              </p>
              <p>&nbsp;</p>
              <p>三、資料利用之期間、地區、對象及方式</p>
              <p>「利用期間」</p>
              <p>
                除法令另有規定者外，將於遊戲內與其所附屬網站服務完畢或至您提出停止使用之請求為止。
              </p>
              <p>&nbsp;</p>
              <p>「利用地區」</p>
              <p>
                台灣地區及提供LINGLUK&nbsp;NETWORK與其所附屬網站服務之地區。
              </p>
              <p>&nbsp;</p>
              <p>「利用對象」</p>
              <p>
                除法令另有規定者外，將僅供你同意之服務目的及LINGLUK&nbsp;NETWORK內部在相關連之範圍內使用，不會任意將您提供的個人資料轉供其他第三人或移作其他目的使用。但基於履行契約目的，將提供相關資料予合作廠商，以完成履行契約義務。
              </p>
              <p>&nbsp;</p>
              <p>「利用方式」</p>
              <p>a.會員資料</p>
              <p>
                您在執行遊戲服務時，LINGLUK&nbsp;NETWORK將會自動蒐集您使用設備之相關資訊，並作為分析您個人遊戲習慣及消費行為，以作為將來提供會員所需之詳盡資料以及作為設計會員活動、遊戲內容優化時之依據。
              </p>
              <p>b.線上交易</p>
              <p>
                如您選擇使用線上交易服務，將會依照你提出的線上交易形態，蒐集您所填寫的訂單相關資料，以確保您完成付款、儲值或物流等消費服務。c.線上活動及調查
              </p>
              <p>
                您若因參加LINGLUK&nbsp;NETWORK舉辦之線上活動或網路調查所留下的個人資料，僅供該次活動或調查使用。這些資料將於活動或調查結束後銷毀。d.統計與分析
              </p>
              <p>
                LINGLUK&nbsp;NETWORK針對您申請遊戲帳號時所取得的資料，以及站內瀏覽時伺服器所產生的紀錄，將不定期進行總體會員行為分析與統計，不會針對個人行為進行分析。四、您得行使的權利及方式
              </p>
              <p>&nbsp;</p>
              <p>
                您就您的個人資料得向LINGLUK&nbsp;NETWORK以書面請求行使以下權利：
              </p>
              <p>a.查詢或請求閱覽。</p>
              <p>b.請求製給複製本。</p>
              <p>c.請求補充或更正。</p>
              <p>d.請求停止蒐集、處理或利用。</p>
              <p>e.請求刪除。</p>
              <p>&nbsp;</p>
              <p>「權利限制」</p>
              <p>
                以上權利，若因您不符合LINGLUK&nbsp;NETWORK申請程序或法令另有規定時，將會受到限制。
              </p>
              <p>&nbsp;</p>
              <p>「酌收費用」</p>
              <p>
                若您就您的個人資料向LINGLUK&nbsp;NETWORK查詢、請求閱覽個人資料或製給複製本時，LINGLUK&nbsp;NETWORK將酌收必要成本費用。
              </p>
              <p>&nbsp;</p>
              <p>「權利行使之方式」</p>
              <p>
                上開權利之申請，應填具申請文件，LINGLUK&nbsp;NETWORK得向您請求提出可資確認之身分證明文件。若委託他人代為申請者，並應出具委任書，且提供本人及代理人之身分證明文件。
              </p>
              <p>&nbsp;</p>
              <p>五、若您無法提供完整的個人資料時，不提供將對您權益之影響</p>
              <p>
                若您無法提供完整且確實的個人資料，將影響LINGLUK&nbsp;NETWORK和您的聯繫、完成交易、提供服務、身份驗證或處理消費、交易或客訴問&nbsp;題。建議您應提供完整的個人資料及隨時更新。若因您未提供完整且確實個人資料，造成對您及第三人發生損害時，您應負擔一切責任，如造成LINGLUK&nbsp;NETWORK的損失時，&nbsp;迪諾遊戲有權向您請求損害賠償。
              </p>
              <p>&nbsp;</p>
              <p>六、個人資料安全維護</p>
              <p>
                關於您的個人資料檔案，LINGLUK&nbsp;NETWORK將採行適當之安全措施，並盡力以合理之技術及措施，依相關法令辦理安全維護事項，防止您的個人資料被竊取、竄改、毀損、滅失或洩漏。
              </p>
              <p>&nbsp;</p>
              <p>七、隱私權政策的修改</p>
              <p>
                LINGLUK&nbsp;NETWORK有權自行修訂隱私權政策，相關修正規定將會公告於本網站，請您密切注意以保障個人權益。當您於隱私權政策任何修改或變更後繼續使用LINGLUK&nbsp;NETWORK網站與其所附屬之網站服務，表示您已閱讀、瞭解並同意接受隱私權政策修改或變更後之內容。
              </p>
              <p>
                如果您不同意本隱私權政策，請您立即停止使用LINGLUK&nbsp;NETWORK網站與其所附屬之網站服務。
              </p>
              <p>&nbsp;</p>
              <p>八、看法與建議</p>
              <p>
                您如果對於LINGLUK&nbsp;NETWORK隱私權政策或與個人資料有關之相關事項有任何意見或疑問，可以和LINGLUK&nbsp;NETWORK客服中心聯絡。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <!-- <p>香港鈴六網絡科技有限公司</p>
            <p>Guangzhou Lulin Technology Co. LTD</p>
            <p>广州市天河区棠下荷光三横路13号301房</p> -->
      <div>
        <p>※本軟體因涉及暴力、打鬥，依遊戲軟體分級管理辦法分類為輔12級</p>
        <p>※遊戲內提供購買虛擬遊戲幣、物品等付費服務</p>
        <p>※請注意遊戲時間，避免沉迷</p>
        <p>※Lingluk Game</p>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../../public/js/jquery.min.js'
export default {
  mounted() {
    $('#focus .imgs ul').width(
      $('#focus .imgs li').length * $('#focus').width()
    )
    $('#focus .ctrl a:eq(0)').addClass('on')
    var focusT

    function focus() {
      focusT = setInterval(function () {
        var i = $('#focus .ctrl a.on').index('#focus .ctrl a') || 0,
          l = $('#focus .ctrl a').length
        i++
        if (i > l - 1) i = 0
        $('#focus .ctrl a').removeClass('on').eq(i).addClass('on')
        $('#focus .imgs ul')
          .stop(true, true)
          .animate(
            {
              left: -$('#focus').width() * i
            },
            600
          )
      }, 8000)
    }
    focus()
    //幻灯
    $('#focus .ctrl a').click(function () {
      clearInterval(focusT)
      var i = $(this).index('#focus .ctrl a')
      $('#focus .ctrl a').removeClass('on').eq(i).addClass('on')
      $('#focus .imgs ul')
        .stop(true, true)
        .animate(
          {
            left: -$('#focus').width() * i
          },
          600,
          function () {
            focus()
          }
        )
    })

    $('.sectionC .next,.sectionC .prev').click(function () {
      var i = $('.sectionC .ctrl a.on').index() || 0,
        l = $('.sectionC .ctrl a').length
      if ($(this).hasClass('next')) {
        i++
        if (i > l - 1) i = 0
      } else {
        i--
        if (i < 0) i = l - 1
      }
      $('.sectionC .ctrl a').removeClass('on').eq(i).addClass('on')
      $('.sectionC .imgs li').removeClass('on').eq(i).addClass('on')
    })
    //特色
    $('.sectionC .ctrl a').click(function () {
      var i = $(this).index()
      $('.sectionC .ctrl a').removeClass('on').eq(i).addClass('on')
      $('.sectionC .imgs li').removeClass('on').eq(i).addClass('on')
    })
    //场景
    $('#scene .ctrl a').click(function () {
      var i = $(this).index('#scene .ctrl a')
      $('#scene .ctrl a').removeClass('on').eq(i).addClass('on')
      $('#scene .imgs li').hide().eq(i).fadeIn(800)
    })
    $('.sider a').click(function () {
      var i = $(this).index()
      if (i < 4) {
        $('html,body').animate(
          {
            scrollTop: $('.section').eq(i).offset().top
          },
          500
        )
      }
    })

    function play_image_list(elementID, effect, play_time) {
      var _div = $('.' + elementID + ' ul')
      var temp_time
      if (_div.children('li').length <= 4) {
        return false
      }
      //play_img("left");
      _div.width(
        _div.children('li').length * (_div.children('li').eq(0).width() + 20)
      )
      if (effect === 'continue') {
        play_time = 30
        _div.css('margin-left', '0px')
      }
      temp_time = setTimeout(function () {
        play_img('left')
      }, play_time)
      _div.parent().hover(
        function () {
          clearTimeout(temp_time)
        },
        function () {
          temp_time = setTimeout(function () {
            play_img('left')
          }, play_time)
        }
      )

      function play_img(type) {
        if (temp_time) {
          clearTimeout(temp_time)
        }
        var div_f = $('.' + elementID + ' ul>li:first'),
          div_l = $('.' + elementID + ' ul>li:last'),
          div_width = div_f.width()
        //alert(div_width);
        if (effect === 'continue') {
          play_time = 30
          var num =
            _div[0].style.marginLeft == '0px'
              ? parseInt(_div[0].style.marginLeft)
              : parseInt(_div[0].style.marginLeft.substring(1))
          num++
          if (num <= div_width + 20) {
            _div.css('margin-left', -num + 'px')
          } else {
            _div.append(div_f)
            _div.css('margin-left', '0px')
          }
        }
        temp_time = setTimeout(function () {
          play_img('left')
        }, play_time)
        return false
      }
    }

    function minWidth() {
      var isIE6 = !-[1] && !window.XMLHttpRequest
      //if(!isIE6){return false;}
      var num = 980
      var w_width = $(window).width()
      if (w_width > num) {
        $('body').width('100%')
      } else {
        $('body').width(980)
      }
    }
    play_image_list('logs', 'continue', 4000)
    var my_jPlayer

    function scrollTxt() {
      var controls = {},
        values = {},
        t1 = 300,
        /*播放动画的时间*/
        t2 = 4000,
        /*播放时间间隔*/
        si
      controls.rollWrap = $('#roll-wrap')
      controls.rollWrapUl = controls.rollWrap.children()
      controls.rollWrapLIs = controls.rollWrapUl.children()
      values.liNums = controls.rollWrapLIs.length
      values.liHeight = controls.rollWrapLIs.eq(0).height()
      values.ulHeight = controls.rollWrap.height()
      this.init = function () {
        autoPlay()
        pausePlay()
      }
      /*滚动*/
      function play() {
        controls.rollWrapUl.animate(
          {
            'margin-top': '-' + values.liHeight
          },
          t1,
          function () {
            $(this).css('margin-top', '0').children().eq(0).appendTo($(this))
          }
        )
      }

      /*自动滚动*/
      function autoPlay() {
        /*如果所有li标签的高度和大于.roll-wrap的高度则滚动*/
        if (values.liHeight * values.liNums > values.ulHeight) {
          si = setInterval(function () {
            play()
          }, t2)
        }
      }

      /*鼠标经过ul时暂停滚动*/
      function pausePlay() {
        controls.rollWrapUl.on({
          mouseenter: function () {
            clearInterval(si)
          },
          mouseleave: function () {
            autoPlay()
          }
        })
      }
    }
    new scrollTxt().init()
  }
}
</script>

<style lang='scss' scoped src='../../../../public/css/home1.css'></style>
<style lang='scss' scoped src='../../../../public/css/copy.css'></style>
<style lang='scss' scoped src='../../../../public/css/black.css'></style>
<style lang="scss" scoped>
.footer p {
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/route/src/lingliu/policy/index.vue